import * as React from 'react';

import AdminUpgradeSidebar from 'admin/components/AdminUpgradeSidebar';
import Image from 'components/Image';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';

import './AdminUpgradeFeatures.scss';

const FEATURES = [
  {
    caption: 'A single platform for consolidating new and existing engagement.',
    image: require('assets/images/admin/AdminUpgradeFeatures/rostering.png'),
    image2x: require('assets/images/admin/AdminUpgradeFeatures/rostering@2x.png'),
  },
  {
    caption: 'Mobile-first notifications for more effective communication.',
    image: require('assets/images/admin/AdminUpgradeFeatures/urgent-messages.png'),
    image2x: require('assets/images/admin/AdminUpgradeFeatures/urgent-messages@2x.png'),
  },
];

export default function AdminUpgradeFeatures() {
  return (
    <AdminUpgradeSidebar
      title="Activate engagement across your organization"
      className="AdminUpgradeFeatures">
      {FEATURES.map(item => (
        <Row size="large" key={item.caption}>
          <figure>
            <Row size="small">
              <Text element="figcaption" size="small">
                {item.caption}
              </Text>
            </Row>
            <Image
              src={item.image}
              srcSet={`${item.image2x} 2x`}
              className="AdminUpgradeFeatures-screenshot"
            />
          </figure>
        </Row>
      ))}
      <Text element="p" size="small">
        See what else is included in a{' '}
        <Link href={LinkConstants.PLANS_GRID} target="_blank">
          Remind Hub
        </Link>
        .
      </Text>
    </AdminUpgradeSidebar>
  );
}
